import { clientSupabase } from "www/shared/modules/supabase";

export const addWaitlistEntry = async (email: string) => {
  const { data, error } = await clientSupabase
    .from("waitlist_emails")
    .insert([{ email }]);

  if (error) {
    throw error;
  }

  return data;
};
